import type { FormContext, StepContext, FormField } from '../types'
import { TrackingEvent } from '../types'

export interface FormSubmittedArgs {
  formContext: FormContext
  stepContext: StepContext
  field: FormField[]
}

export interface FormSubmittedProperties {
  formContext: FormContext
  stepContext: StepContext
  field: FormField[]
}

export class FormSubmitted extends TrackingEvent {
  properties: FormSubmittedProperties

  constructor(args: FormSubmittedArgs) {
    const {
      formContext = {
        formName: '',
        formType: '',
        formVersion: '',
        formId: '',
      },
      stepContext = {
        stepId: '',
        stepName: '',
        stepNumber: 0,
      },
      field = [],
    } = args ?? {}

    super('FormSubmitted', 'redventures.usertracking.v3.FormSubmitted')

    this.properties = {
      formContext: {
        formName: formContext.formName,
        formType: formContext.formType,
        formVersion: formContext.formVersion,
        formId: formContext.formId,
      },
      stepContext: {
        stepId: stepContext.stepId,
        stepName: stepContext.stepName,
        stepNumber: stepContext.stepNumber,
      },
      field: field,
    }
  }
}
